import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const ActivitySectionTitle = ({ title, icon, classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("span", { className: css(styles.header) }, title),
        icon));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    header: {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: 1.28,
    },
    icon: {
        width: 24,
    },
});
